import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/login",
    meta: { title: "Legend - Redirect" },
  },
  {
    path: "/login",
    name: "SetPassword",
    component: () => import("@/views/SetupPassword.vue"),
    meta: {
      title: "",
      transition: "fade",
      requiresAuth: true,
    },
  },
  {
    path: "/date-picker",
    name: "DatePicker",
    component: () => import("@/views/DatePicker.vue"),
    meta: {
      title: "Legend - Select Date",
      requiresAuth: true,
      transition: "fade",
    },
  },
  {
    path: "/time-slots",
    name: "TimeSlots",
    component: () => import("@/views/TimeSlotSelector.vue"),
    meta: {
      title: "Legend - Select Time Slot",
      requiresAuth: false, // Temporarily disabled auth
      transition: "slide",
    },
  },
  {
    path: "/time-slots",
    name: "TimeSlots",
    component: () => import("@/views/TimeSlotSelector.vue"),
    meta: {
      title: "Legend - Select Time Slot",
      requiresAuth: false, // Temporarily disabled auth
      transition: "slide",
    },
  },
  {
    path: "/dashboard",
    name: "BookInstaller",
    component: () => import("@/views/BookInstaller.vue"),
    meta: {
      title: "Legend - Book Installer",
      requiresAuth: false, // Temporarily disabled auth
    },
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: () => import("@/views/ConfirmationPage.vue"),
    meta: {
      title: "Legend - Booking Confirmed",
      requiresAuth: true, // Temporarily disabled auth
    },
  },
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   component: () => import("@/views/InstallerDashboard.vue"),
  //   meta: {
  //     title: "Legend - Dashboard",
  //     requiresAuth: true, // Temporarily disabled auth
  //   },
  // },
  {
    path: "/installer/:id",
    name: "InstallerProfile",
    component: () => import("@/views/InstallerProfile.vue"),
    props: true,
    meta: {
      title: "Legend - Installer Profile",
      requiresAuth: true, // Temporarily disabled auth
    },
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/set-password'
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || "/"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 };
  },
});

// Simplified navigation guard - only sets title
router.beforeEach((to) => {
  document.title = to.meta.title || "Legend App";
});

export default router;
